// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2de1bb7","455":"e8ba0380","977":"61537a3d"}[chunkId] + ".chunk.js";
};